export default __webpack_public_path__ + "static/media/miniHeartsFoundation.291180b5.svg";